export const ASSET_TYPES = {
  TITLE: 'title',
  CRM: 'crm',
} as const;

export type AssetType = (typeof ASSET_TYPES)[keyof typeof ASSET_TYPES];

export const ROYALTY_RATE_OPTIONS = {
  NONE: 'None',
  TWELVE_POINT_FIVE: '12.5%',
  TWENTY_FIVE: '25%',
} as const;

export type RoyaltyRateOption =
  (typeof ROYALTY_RATE_OPTIONS)[keyof typeof ROYALTY_RATE_OPTIONS];

export const DEFAULT_PARTICIPATION_FACTOR_THRESHOLD = 0.97;
